// Shared by the Home Dashboard Calendar's grid + chip components (issue
// #229). A pinned colour per type rather than Pill.js's categoricalColor
// hash — there are only three fixed calendar item types, so an explicit
// value reads more reliably than whatever the hash happens to land on (see
// Pill.js's own CategoryPill comment on pinning vs. hashing for a small
// fixed set). All three are drawn from the app's existing CATEGORY_PALETTE
// (Pill.js), not invented new hues.
export const CALENDAR_ITEM_COLORS = {
  meeting: '#1976d2',
  call: '#7b1fa2',
  task: '#5d4037',
  // Trade Shows with a date (a quick fix ahead of the Events and Platform
  // Calendar visions, which replace Trade Shows on the calendar).
  trade_show: '#00838f',
};

// Local YYYY-MM-DD — avoids toISOString()'s UTC conversion shifting the day
// in a timezone behind UTC, since this turns a local Date built from y/m/d
// back into a DATEONLY string.
export function toISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
